export default class TextHelper {
    static onlyAscii = (str) => {
        return str.replace(/[^\x00-\x7F]/g, "")
    }
}